var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { manageService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var SysParamService = /** @class */ (function (_super) {
    __extends(SysParamService, _super);
    function SysParamService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 修改系统参数
     */
    SysParamService.prototype.modifySysParam = function (data, loading) {
        return this.netService.send({
            server: manageService.sysParamController.modifySysParam,
            data: data,
            loading: loading
        });
    };
    /**
     * 多条件查询系统参数
     */
    SysParamService.prototype.findAllSysParam = function (data, page, sort, loading) {
        return this.netService.send({
            server: manageService.sysParamController.findAllSysParam,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], SysParamService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], SysParamService.prototype, "modifySysParam", null);
    __decorate([
        Debounce()
    ], SysParamService.prototype, "findAllSysParam", null);
    return SysParamService;
}(Service));
export { SysParamService };
